import React from 'react'
import CreateVisaPackageWorker from './create'
import { Link, withRouter } from 'react-router-dom'
import VisaPackageForm from '../components/form/form.component'
import FormHelper from '../../../../utils/FormHelper'
import Dialog from '../../../../components/dialog/dialog.component'
import Loading from '../../../../components/loading/loading.component'
import './create.styles.scss'

class CreateVisaPackage extends React.Component {

    constructor(props) {
        super(props)
        this.createVisaPackageWorker = CreateVisaPackageWorker(this)
        this.state = this.createVisaPackageWorker.getDefaultState()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.createVisaPackageWorker.isValid() && this.createVisaPackageWorker.createVisaPackage()
    }

    onCancel = () => this.props.history.push('/content/visa-packages')

    render() {
        return (
            <div className="create-visa-package">
                {
                    this.state.creatingVisaPackage && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/content/visa-packages">Visa Packages</Link>
                    <div className="header">
                        <h4>Create Visa Package</h4>
                    </div>
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <VisaPackageForm {...this.state} action="Add Visa Package" onChange={FormHelper(this).onChange} onSubmit={this.onSubmit} onCancel={this.onCancel} />
                </div>
            </div>
        )
    }
}

export default withRouter(CreateVisaPackage)
